import { html, LitElement, nothing } from 'lit';
import { property } from 'lit/decorators.js';
import { IxPricingStyles } from './ix-pricing-styles.js';
import { transformPricingData } from './utils/transformPricingData.js';

export type Frequency = 'Monthly' | 'OneTime';

export interface Product {
  product: {
    id: string;
    name: string;
  };
  price_list: {
    amount: {
      unit: string;
      value: number;
    };
    frequency: Frequency;
  }[];
}

interface Labels {
  product: string;
  quantity: string;
  monthlyCharges: string;
  oneOffCharges: string;
  totalCharges: string;
  totalOneOffFee: string;
  totalMonthlyFee: string;
  genericError: string;
}

interface PricingData {
  total: {
    monthly: string;
    oneTime: string;
  };
  products: {
    monthly: string;
    oneTime: string;
    quantity: number;
    Monthly: number;
    OneTime: number;
    name: string;
  }[];
}

export class IxPricing extends LitElement {
  static get styles() {
    return [IxPricingStyles];
  }

  @property({ type: Object }) labels: Labels = {
    product: 'Product',
    quantity: 'QTY',
    monthlyCharges: '',
    oneOffCharges: '',
    totalCharges: '',
    totalOneOffFee: '',
    totalMonthlyFee: '',
    genericError: 'Error',
  };

  @property() error: string = '';

  @property({ type: Array }) products: Product[] = [];

  private pricingData: PricingData | undefined = undefined;

  willUpdate() {
    try {
      this.pricingData = transformPricingData(this.products);
    } catch {
      this.error = this.labels?.genericError;
    }
  }

  renderError() {
    return this.error ? html`<p>${this.error}</p>` : nothing;
  }

  renderRows() {
    return (
      this.pricingData?.products?.map(
        product => html`
          <tr>
            <td>${product.name}</td>
            <td class="quantity">${product.quantity}</td>
            <td>${product.monthly}</td>
            <td>${product.oneTime}</td>
          </tr>
        `
      ) || nothing
    );
  }

  render() {
    if (this.error) {
      return this.renderError();
    }
    return this.pricingData?.products?.length
      ? html`
          <table>
            <tr>
              <th></th>
              <th></th>
              <th colspan="2">${this.labels?.totalCharges}</th>
            </tr>
            <tr>
              <th>${this.labels?.product}</th>
              <th>${this.labels?.quantity}</th>
              <th>${this.labels?.monthlyCharges}</th>
              <th>${this.labels?.oneOffCharges}</th>
            </tr>
            ${this.renderRows()}
            <tr>
              <td>${this.labels?.totalOneOffFee}</td>
              <td id="nrc-total">${this.pricingData.total.oneTime}</td>
            </tr>
            <tr>
              <td>${this.labels?.totalMonthlyFee}</td>
              <td id="mrc-total">${this.pricingData.total.monthly}</td>
            </tr>
          </table>
        `
      : html`<p>${this.labels.genericError}</p>`;
  }
}
